document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContador();
  initGaleriaProducto();
  initVariantesProducto();
  initAcordeonFaq();
  initMarquesina();
  initCuentaAtras();
  initCupon();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.getAttribute('data-mt-delay') || 0;
        setTimeout(function () { entry.target.classList.add('mt-visible'); }, Number(delay));
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
}

function initContador() {
  var nums = document.querySelectorAll('[data-mt-contador]');
  if (!nums.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      animarContador(entry.target);
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.4 });
  nums.forEach(function (el) { observer.observe(el); });
}

function animarContador(el) {
  var target = parseFloat(el.getAttribute('data-mt-contador'));
  var suffix = el.getAttribute('data-mt-sufijo') || '';
  var esDecimal = target % 1 !== 0;
  var pasosTotales = 30;
  var paso = 0;
  function formatea(valor) { return (esDecimal ? valor.toFixed(1) : Math.round(valor)) + suffix; }
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    el.textContent = formatea(target);
    return;
  }
  var intervalo = setInterval(function () {
    paso++;
    if (paso >= pasosTotales) {
      el.textContent = formatea(target);
      clearInterval(intervalo);
      clearTimeout(seguro);
      return;
    }
    var progreso = paso / pasosTotales;
    var valor = target * (1 - Math.pow(1 - progreso, 3));
    el.textContent = formatea(valor);
  }, 1400 / pasosTotales);
  // Salvaguarda: si el intervalo se ralentiza (pestaña en segundo plano, etc.),
  // fuerza el valor final para que nunca quede una cifra a medias.
  var seguro = setTimeout(function () {
    clearInterval(intervalo);
    el.textContent = formatea(target);
  }, 2200);
}

function initGaleriaProducto() {
  var wrap = document.querySelector('[data-mt-galeria]');
  if (!wrap) return;

  // Quita la descarga del reproductor: 'controlsList' oculta el botón y esto
  // bloquea el clic derecho. No es una protección real (la URL del mp4 sigue
  // en el código de la página), solo evita la descarga a un clic.
  var video = wrap.querySelector('[data-mt-galeria-video]');
  if (video) {
    video.addEventListener('contextmenu', function (e) { e.preventDefault(); });
  }

  var miniaturas = wrap.querySelectorAll('[data-mt-galeria-mini]');
  miniaturas.forEach(function (mini) {
    mini.addEventListener('click', function () {
      mostrarMediaGaleria(wrap, mini);
      miniaturas.forEach(function (m) { m.classList.remove('mt-mini-activa'); });
      mini.classList.add('mt-mini-activa');
    });
  });
}

// Pinta en el visor grande lo que corresponda: una foto o un vídeo.
function mostrarMediaGaleria(wrap, mini) {
  var principal = wrap.querySelector('[data-mt-galeria-principal]');
  var video = wrap.querySelector('[data-mt-galeria-video]');
  var marco = wrap.querySelector('.mt-galeria-principal-wrap');
  var esVideo = mini.getAttribute('data-mt-tipo') === 'video';
  var alt = mini.getAttribute('data-alt') || '';

  if (esVideo && video) {
    var url = mini.getAttribute('data-video');
    if (!url) return;
    if (video.getAttribute('src') !== url) {
      video.innerHTML = '';
      video.setAttribute('src', url);
      video.setAttribute('poster', mini.getAttribute('data-full') || '');
      video.load();
    }
    video.hidden = false;
    if (principal) principal.hidden = true;
    // El marco pasa a formato vertical para que quepan los controles del reproductor.
    if (marco) marco.classList.add('mt-galeria-wrap--video');
    return;
  }

  var full = mini.getAttribute('data-full');
  if (!full || !principal) return;
  if (video) { video.pause(); video.hidden = true; }
  if (marco) marco.classList.remove('mt-galeria-wrap--video');
  principal.hidden = false;
  principal.src = full;
  principal.alt = alt;
}

function initVariantesProducto() {
  var form = document.querySelector('[data-mt-producto-form]');
  if (!form) return;
  var dataEl = document.querySelector('[data-mt-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var selects = form.querySelectorAll('[data-mt-opcion]');
  var inputId = form.querySelector('[data-mt-input-id]');
  var precioEl = document.querySelector('[data-mt-precio]');
  var precioCompareEl = document.querySelector('[data-mt-precio-compare]');
  var boton = form.querySelector('[data-mt-boton-comprar]');

  function opcionesSeleccionadas() {
    var vals = [];
    selects.forEach(function (s) { vals.push(s.value); });
    return vals;
  }

  function formatoMoneda(centavos) {
    return (centavos / 100).toLocaleString('es-ES', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
  }

  function actualizar() {
    var sel = opcionesSeleccionadas();
    var variante = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === sel[i]; });
    });
    if (!variante) return;
    if (inputId) inputId.value = variante.id;
    if (precioEl) precioEl.textContent = formatoMoneda(variante.price);
    if (precioCompareEl) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        precioCompareEl.textContent = formatoMoneda(variante.compare_at_price);
        precioCompareEl.style.display = '';
      } else {
        precioCompareEl.style.display = 'none';
      }
    }
    if (boton) {
      if (variante.available) {
        boton.disabled = false;
        boton.setAttribute('data-estado', 'disponible');
      } else {
        boton.disabled = true;
        boton.setAttribute('data-estado', 'agotado');
      }
    }
    actualizarGaleriaPorColor(sel[0]);
  }

  selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  actualizar();
}

function actualizarGaleriaPorColor(color) {
  if (!color) return;
  var wrap = document.querySelector('[data-mt-galeria]');
  if (!wrap) return;
  var miniaturas = wrap.querySelectorAll('[data-mt-galeria-mini]');
  var primera = null;

  miniaturas.forEach(function (mini) {
    // data-mt-color viene como "|Negro|Rosa|": un media puede valer para varios colores.
    var lista = mini.getAttribute('data-mt-color') || '';
    var coincide = lista.indexOf('|' + color + '|') !== -1;
    mini.hidden = !coincide;
    // La primera visible que NO sea vídeo manda en el visor, para no arrancar
    // con el reproductor en vez de con una foto del color elegido.
    if (coincide && !primera && mini.getAttribute('data-mt-tipo') !== 'video') primera = mini;
  });

  if (!primera) {
    miniaturas.forEach(function (mini) {
      if (!mini.hidden && !primera) primera = mini;
    });
  }
  if (!primera) return;

  mostrarMediaGaleria(wrap, primera);
  miniaturas.forEach(function (m) { m.classList.remove('mt-mini-activa'); });
  primera.classList.add('mt-mini-activa');
}

function initAcordeonFaq() {
  var items = document.querySelectorAll('[data-mt-faq-pregunta]');
  items.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('[data-mt-faq-item]');
      var abierto = item.classList.contains('mt-faq-abierta');
      item.parentElement.querySelectorAll('[data-mt-faq-item]').forEach(function (i) {
        i.classList.remove('mt-faq-abierta');
      });
      if (!abierto) item.classList.add('mt-faq-abierta');
    });
  });
}

function initMarquesina() {
  document.querySelectorAll('[data-mt-marquesina]').forEach(function (track) {
    if (track.dataset.mtDuplicado) return;
    track.innerHTML += track.innerHTML;
    track.dataset.mtDuplicado = '1';
  });
}

function initCuentaAtras() {
  var cajas = document.querySelectorAll('[data-mt-cuenta-atras]');
  if (!cajas.length) return;

  cajas.forEach(function (caja) {
    var reloj = caja.querySelector('[data-mt-reloj]');
    if (!reloj) return;

    // Acepta "2026-09-21 23:59" y también "2026-09-21T23:59".
    var bruto = (caja.getAttribute('data-mt-fin') || '').trim().replace(' ', 'T');
    if (bruto.length === 16) bruto += ':00';
    var fin = new Date(bruto).getTime();
    if (isNaN(fin)) { caja.style.display = 'none'; return; }

    var textoAgotado = caja.getAttribute('data-mt-agotado') || 'Oferta finalizada';

    function dosDigitos(n) { return n < 10 ? '0' + n : String(n); }

    function pintar() {
      var restante = fin - Date.now();

      if (restante <= 0) {
        var etiqueta = caja.querySelector('.mt-oferta-cuenta-etiqueta');
        if (etiqueta) etiqueta.remove();
        reloj.textContent = textoAgotado;
        clearInterval(temporizador);
        return;
      }

      var totalSeg = Math.floor(restante / 1000);
      var dias = Math.floor(totalSeg / 86400);
      var horas = Math.floor((totalSeg % 86400) / 3600);
      var mins = Math.floor((totalSeg % 3600) / 60);
      var segs = totalSeg % 60;

      reloj.textContent = dias > 0
        ? dias + 'd ' + dosDigitos(horas) + 'h ' + dosDigitos(mins) + 'm ' + dosDigitos(segs) + 's'
        : dosDigitos(horas) + ':' + dosDigitos(mins) + ':' + dosDigitos(segs);
    }

    pintar();
    var temporizador = setInterval(pintar, 1000);
  });
}

function initCupon() {
  var caja = document.querySelector('[data-mt-cupon]');
  if (!caja) return;

  var input = caja.querySelector('[data-mt-cupon-input]');
  var boton = caja.querySelector('[data-mt-cupon-boton]');
  var aviso = caja.querySelector('[data-mt-cupon-aviso]');
  if (!input || !boton) return;

  function aplicar() {
    var codigo = (input.value || '').trim();
    if (!codigo) {
      if (aviso) {
        aviso.textContent = 'Escribe un código para aplicarlo.';
        aviso.hidden = false;
      }
      input.focus();
      return;
    }
    boton.disabled = true;
    boton.classList.add('mt-cupon-boton--cargando');
    // Ruta oficial de Shopify para aplicar un código desde la tienda:
    // guarda el descuento en la sesión y vuelve al carrito ya aplicado.
    window.location.href = '/discount/' + encodeURIComponent(codigo) + '?redirect=/cart';
  }

  boton.addEventListener('click', aplicar);
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); aplicar(); }
  });
  input.addEventListener('input', function () {
    if (aviso) aviso.hidden = true;
  });
}
